export const requestOptionsGet = {
  method: "GET",
  mode: "cors",
  headers: {
    // "X-Content-Type-Options": "nosniff",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};
